import { Aurelia, autoinject, bindable, bindingMode } from 'aurelia-framework';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { Config } from 'Config';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { I18N } from 'aurelia-i18n';
import { Toastr } from 'Code/Extension/Toastr';
import { Router } from 'aurelia-router';

function preparePlatform() {

    //https://console.cloud.google.com/apis/credentials?project=vistos-crm&folder=&organizationId=
    //https://developers.google.com/identity/sign-in/web/build-button
    // The name of the global function the platform API will call when it's ready.
    const platformCallbackName = 'setGooglePlatformReady';
    // An "API ready" promise that will be resolved when the platform API is ready.
    const ready = new Promise(resolve => window[platformCallbackName] = resolve);

    // Inject the client id meta tag
    const meta = document.createElement('meta');
    meta.name = 'google-signin-client_id';
    meta.content = '165242578086-jovdrl2pfivcheks9mlu2ka2pioocgue.apps.googleusercontent.com';
    document.head.appendChild(meta);

    // Inject an async script element to load the google platform API.
    // Notice the callback name is passed as an argument on the query string.
    const script = document.createElement('script');
    script.src = `https://apis.google.com/js/platform.js?onload=${platformCallbackName}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    return ready;
}

const platformReady = preparePlatform();

@autoinject
export class Login {

    @bindable({ defaultBindingMode: bindingMode.toView }) userName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) password: string = StringHelper.Empty();

    protected router: Router = null;
    private imageLogo: string = null;
    private progressImageLogo: string = null;
    private i18n: I18N = null;
    private _authService: AuthService = null;
    private _aurelia: Aurelia = null;
    private _element: any = null;
    private _isValid: boolean = true;
    private _badLogin: boolean = false;
    private _emptyUsername: boolean = false;
    private _emptyPassword: boolean = false;
    private badLoginMess: string = '';
    private activeLoginGoogle: boolean = false;
    private formMode: string = 'NormalLogin';
    private verificationGuid: string = null;
    private verifCode: string = null;
    private _emptyVerifCode: boolean = false;
    private _badTwoFactorAuthenticationVerification: boolean = false;

    constructor(authService: AuthService, aurelia: Aurelia, element: Element, i18n: I18N, router: Router) {
        this.i18n = i18n;
        this._authService = authService;
        this._aurelia = aurelia;
        this._element = element;
        this.router = router;
        let windwowNavigator: any = window.navigator;
        let browserLanguage = windwowNavigator.languages && windwowNavigator.languages[0] || windwowNavigator.language || windwowNavigator.userLanguage;;
        switch (browserLanguage.toLowerCase().substring(0, 2)) {
            case 'cs': this.i18n.setLocale(browserLanguage.toLowerCase().substring(0, 2)); break;
            default: this.i18n.setLocale('en'); break;
        }
    }

    attached() {
        platformReady.then(this.renderButton);
        console.log(11, 'attached');
    }

    private renderButton = () => {
        gapi.signin2.render('my-signin2', {
            scope: 'profile email',
            width: 200,
            height: 36,
            longtitle: true,
            theme: 'dark',
            onsuccess: async googleUser => {
                if (this.activeLoginGoogle) {
                    const id_token: string = googleUser.getAuthResponse().id_token;
                    console.info(1111, 'googleUser.getAuthResponse()', googleUser, 2222, id_token);
                    let response: any = await this._authService.AuthGoogle(id_token);
                    console.log(1111, 'Visots API AuthGoogle response', response)
                    if (ObjectHelper.ObjectIs(response) && response.Status == 0) {
                        await this.InitApp();
                    }
                    else {
                        this._badLogin = true;
                        this.badLoginMess = response.Message;
                    }
                }
                this.activeLoginGoogle = false;
            },
            onfailure: error => {
                console.error(error);
                this.activeLoginGoogle = false;
            }
        });
    }

    bind() {
        this.imageLogo = Config.ImageLogo();
        this.progressImageLogo = Config.ProgressImageLogo();
        console.log(11, 'bind');
    }

    verifCodeChanged(newValue) {
        if (ObjectHelper.IsNotNullAndUndefined(newValue) && !StringHelper.IsNullOrEmpty(newValue)) {
            this._emptyVerifCode = false;
        }
    }

    userNameChanged(newValue) {
        if (ObjectHelper.IsNotNullAndUndefined(newValue) && !StringHelper.IsNullOrEmpty(newValue)) {
            this._emptyUsername = false;
        }

        if (!this._emptyUsername && !this._emptyPassword) {
            this._isValid = true;
        }
    }

    passwordChanged(newValue) {
        if (ObjectHelper.IsNotNullAndUndefined(newValue) && !StringHelper.IsNullOrEmpty(newValue)) {
            this._emptyPassword = false;
        }

        if (!this._emptyUsername && !this._emptyPassword) {
            this._isValid = true;
        }
    }

    public async LoginGoogle() {
        this.activeLoginGoogle = true;
    }

    private async InitApp() {
        Config.Init();

        ($('#progress-overlayer-white') as any).fadeIn(50);

        await SystemService.Instance.ClearCache_All();
        await SystemService.Instance.GetSchema();

        ($('#progress-overlayer-white') as any).delay(1000).fadeOut(350);

        return this._aurelia.setRoot('App');
    }

    public async VerificationCode() {
        this._isValid = true;
        this._badTwoFactorAuthenticationVerification = false;
        this.badLoginMess = '';
        this._emptyVerifCode = StringHelper.IsNullOrEmpty(this.verifCode);
        if (StringHelper.StringIs(this.verificationGuid) && StringHelper.StringIs(this.verifCode)) {
            let response = await this._authService.TwoFactorAuthenticationVerification(this.verificationGuid, this.verifCode);
            if (ObjectHelper.ObjectIs(response) && response['status'] == 'OK') {
                if (ObjectHelper.ObjectIs(response['data']['Token']) && StringHelper.StringIs(response['data']['Token'])) {
                    this.formMode = 'NormalLogin';
                    this.verificationGuid = null;
                    await this.InitApp();
                }
            }
        }
        this._badTwoFactorAuthenticationVerification = true;
    }

    public async Login() {
        this._isValid = true;
        this._badLogin = false;
        this.badLoginMess = '';
        this._emptyUsername = StringHelper.IsNullOrEmpty(this.userName);
        this._emptyPassword = StringHelper.IsNullOrEmpty(this.password);

        if (!this._emptyUsername && !this._emptyPassword) {
            let response = await this._authService.Login(this.userName, this.password);
            if (response['status'] == 'OK') {
                if (ObjectHelper.ObjectIs(response['data']['Token']) && StringHelper.StringIs(response['data']['Token'])) {
                    await this.InitApp();
                } else if (ObjectHelper.ObjectIs(response['data']['VerificationGuid']) && StringHelper.StringIs(response['data']['VerificationGuid'])) {
                    this.verificationGuid = response['data']['VerificationGuid'];
                    this.formMode = 'TwoFactorAuthenticationVerification';
                }
            }
            else {
                this._isValid = false;

                switch (response['status']) {
                    case 'LoginPermanentlyBlocked':
                        // TODO: Zobrazit hlasku 
                        this.badLoginMess = this.i18n.tr('Login.LoginBannedForever');
                        this._badLogin = true;
                        break;
                    case 'LoginTemporarilyBlocked':
                        this.badLoginMess = this.i18n.tr('Login.LoginBanned') + moment(response['data']['loginBannedUntil']).locale(this.i18n.getLocale()).format('l LT');
                        this._badLogin = true;
                        break;
                    case 'InvalidLogin':
                        this.badLoginMess = this.i18n.tr('Login.BadLogin');
                        this._badLogin = true;
                        break;
                    default:
                        this._badLogin = true;
                        break;
                }
            }
        }
        else {
            this._isValid = false;
        }
    }

    public ShowPwd() {
        console.log(9999999, 'ShowPwd');
        let x: any = document.getElementById("password");
        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
    }

    public async ResetPwd() {
        this._badLogin = false;
        this.badLoginMess = '';
        this._emptyUsername = StringHelper.IsNullOrEmpty(this.userName);
        if (!this._emptyUsername) {
            let response: any = await this._authService.ResetPwd(this.userName);
            //console.log(1111, 'ResetPwd', response)
            if (ObjectHelper.ObjectIs(response) && response.Status == 0) {
                Toastr.Success('An email has been sent to reset your password', response.Message, true, 20000);
            }
            else {
                this._badLogin = true;
                this.badLoginMess = response.Message;
            }
        }
    }

    public async RegisterLink() {
        this.router.navigateToRoute('register');
    }
}